// import {HTTPServer} from '@/common/js/ajax'
import * as types from '../mutations-types'

const state = {
  webform_layout: {},
  delete_omponent: {},
  page_layout: {}
}

// getters
const getters = {
  getCurrentLayout: state => index => {
    // 当前编辑的字段
    return state.enableFields[index]
  },
  getEnableLayout: state => () => {
    // 获取使用的布局
    return state.webform_layout.enableLayout.slice(0, state.webform_layout.enableLayout.length)
  },
  get: state => () => {
    // 获取使用的布局
    return state.webform_layout.enableLayout.slice(0, state.webform_layout.enableLayout.length)
  },
  getDisableLayout: state => () => {
    // 获取未使用的字段
    return state.webform_layout.disableLayout
  },
  getFromProps: state => () => {
    // 获取表单属性
    return state.webform_layout.formProps
  },
  getPageLayout: state => index => {
    // 当前编辑的字段
    return state.page_layout
  }
  // cartProducts: (state, getters, rootState) => {
  //   return state.added.map(({ id, quantity }) => {
  //     const product = rootState.products.all.find(product => product.id === id)
  //     return {
  //       title: product.title,
  //       price: product.price,
  //       quantity
  //     }
  //   })
  // },
  // cartTotalPrice: (state, getters) => {
  //   return getters.cartProducts.reduce((total, product) => {
  //     return total + product.price * product.quantity
  //   }, 0)
  // }
}
// actions
const actions = {
  // getInitCondition: ({ commit, state }) => {
  //   HTTPServer.getInitCondition(state.currentBean)
  //   .then((res) => {
  //     commit('SET_CONDITIONS', res)
  //   })
  // },
  // getAllFieldList: ({commit, state}) => {
  //   HTTPServer.getAllFieldList(state.currentBean)
  //   .then((res) => {
  //     commit('SET_ALL_FIELDS', res)
  //   })
  // }
  // setModuleBean: ({commit, state}, {sourceParams}) => {
  //   commit('SWITCH_SOURCE_BEAN', sourceParams)
  // }
}

// mutations
const mutations = {
  [types.SET_WEBFORM_LAYOUT](state, allLayout) {
    state.webform_layout = allLayout
  },
  [types.SET_DISAB_FIELDS](state, component) {
    if (component.type === 'delete') {
      state.webform_layout.disableLayout.push(component.field)
    } else if (component.type === 'renew') {
      state.webform_layout.disableLayout = component.field
    }
  },
  [types.SET_WEBFOTM_ENABLE](state, value) {
    // 设置使用的布局
    state.webform_layout.enableLayout = JSON.parse(JSON.stringify(value))
  },
  [types.SET_WEBFOTM_PROPS](state, value) {
    state.webform_layout.formProps = JSON.parse(JSON.stringify(value))
  },
  [types.SET_PREVIEW_LAYOUT](state, value) {
    state.webform_layout.formProps = JSON.parse(JSON.stringify(value))
  },
  [types.SET_PAGE_LAYOUT](state, pageLayout) {
    state.page_layout = pageLayout
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
